import React from 'react';

import { styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const Typography_LoginPageSubtitle = styled(Typography)(({ theme }) => ({
  width: 280,
  textAlign: 'center',
  marginTop: theme.spacing(1),
}));

const LoginPageSubtitle = ({ children }) => (
  <Typography_LoginPageSubtitle variant="bodyLight" component="p">
    {children}
  </Typography_LoginPageSubtitle>
);

LoginPageSubtitle.propTypes = {
  children: PropTypes.node,
};

export default LoginPageSubtitle;
